import { TranslationGroup } from '../i18n/tanslation-group';
import { mmTableConstants } from './mm-table-constants';
import { en, zh } from './i18n';

export const mmTableTranslationGroup = {
    groupName: mmTableConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup;